module.exports = __webpack_public_path__ + "static/img/lg-bg.6d273a44.jpg";